<template>
  <div class="container">
    <h3 class="sectionTitle" data-aos="fade-up">Організатор проєкту</h3>
    <div class="itemsContainer">
      <a
        rel="noreferrer noopener"
        target="_blank"
        href="https://best-lviv.org.ua/"
        class="imgLink"
        data-aos="fade-up"
      >
        <div class="imageContainer">
          <img
            class="infoImg"
            src="@/assets/icons/bestIcon.svg"
            alt="bestIcon"
          />
        </div>
      </a>
      <p class="text18 block-text" data-aos="fade-up">
        <span style="font-weight: bold">
          BEST (Board of European Students of Technology)</span
        >
        – неприбуткова громадська організація, яка об’єднує студентів технічних
        спеціальностей для забезпечення обміну знаннями та співпраці компаній,
        університетів та студентів Європи.
      </p>
    </div>
    <div class="itemsContainer lowerContainer">
      <div class="infoWrapper">
        <div class="block-text">
          <p class="text40" data-aos="fade-up">Місія</p>
          <p class="text18" data-aos="fade-up">
            – розвиток студентів. BEST допомагає студентам досягти міжнародності
            мислення, кращого розуміння культур та народів, а також розвинути
            навички роботи в міжнародному середовищі.
          </p>
        </div>
      </div>
      <div class="infoWrapper">
        <div class="block-text">
          <p class="text40" data-aos="fade-up">Візія</p>
          <p class="text18" data-aos="fade-up">
            – сила в різноманітті. Ми розуміємо та поважаємо різні культури та
            суспільства. Створене середовище підтримує будь-яких людей у
            реалізації їхнього потенціалу та відповідальній діяльності.
          </p>
        </div>
      </div>
    </div>

    <div class="iconsWrapper">
      <div class="iconItem" data-aos="fade-up">
        <p class="text64">86</p>
        <p class="text18">Осередків</p>
      </div>
      <div class="iconItem" data-aos="fade-up">
        <p class="text64">30</p>
        <p class="text18">Країн</p>
      </div>
      <div class="iconItem" data-aos="fade-up">
        <p class="text64">30</p>
        <p class="text18">Років досвіду</p>
        <p class="text64 iconPlus">+</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Organisator'
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.infoWrapper {
  max-width: 100%;
}

.itemsContainer {
  margin-top: 3.7rem;
  width: 100%;
  gap: 5rem;
  display: flex;
  justify-content: space-between;
}

.lowerContainer {
  margin-top: 7rem;
}

.infoImg {
  width: 25.172rem;
  margin-right: 12.69rem;
}

.block-text {
  width: 25.034rem;
}

.infoText {
  width: 23.2rem;
}

.iconsWrapper {
  max-width: 100%;
  margin-top: 11.25rem;
  display: flex;
  justify-content: space-between;
}

.iconItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.IconText {
  text-align: center;
}

.iconPlus {
  right: 0;
  top: -2.5rem;
  position: absolute;
  font-weight: 300;
}

@media screen and (max-width: 768px) {
  .itemsContainer {
    flex-direction: column;
  }

  .lowerContainer {
    margin-top: auto;
  }
  .infoImg {
    width: 46.875rem;
    height: auto;
  }
  .imageContainer {
    display: flex;
    justify-content: center;
  }
  .infoWrapper {
    flex-direction: column;
    margin-top: 7.5rem;
    align-items: center;
  }
  .block-text {
    width: 100%;
  }
  .infoText {
    margin-top: 7.5rem;
  }
  .iconsWrapper {
    margin-top: 15.625rem;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .iconPlus {
    right: 33%;
    top: -8rem;
  }
  .iconItem {
    flex: 50%;
  }
  .iconItem:last-child {
    flex: 100%;
    margin-top: 15.625rem;
  }
}
</style>
